const isActiveLocalHost = false;
// export let HOST_NAME: string = "http://localhost:8000";
export let HOST_NAME: string = "https://apibeta.uiwiki.co";
export let FRONTEND_HOST_NAME: string = "https://beta.uiwiki.co";
export let GEMINI_AI_KEY: string = "AIzaSyCEQ24lTtEN1OAQOmORPwOI5cdNV8sQpTk";

const hostname = window.location.hostname; // Extracts only the domain (e.g., "admin.uiwiki.co")

// Define production hostnames and corresponding API URLs
const domainMappings: { [key: string]: string } = {
  "admin.uiwiki.co": "https://api.uiwiki.co",
  "adminbeta.uiwiki.co": "https://apibeta.uiwiki.co",
};

// Set HOST_NAME based on the current domain
if (!isActiveLocalHost && domainMappings[hostname]) {
  HOST_NAME = domainMappings[hostname];
}

// container min height
export const SECTION_MIN_HEIGHT = `calc(100vh - 76px)`;

export const selectedRangeStartEndDate = (range: string) => {
  switch (range?.toUpperCase()) {
    case "THIS MONTH":
      return {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(),
      };
    case "LAST MONTH":
      return {
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      };
    case "LAST 3 MONTH":
      return {
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          1
        ),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      };
    case "LAST 6 MONTH":
      return {
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 5,
          1
        ),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      };
    case "LAST 1 YEAR":
      return {
        startDate: new Date(
          new Date().getFullYear() - 1,
          new Date().getMonth() + 1,
          1
        ),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      };
    case "THIS WEEK": {
      const today = new Date();
      const startOfWeek = today.getDate() - today.getDay() + 1; // Start of current week (Monday)
      const endOfWeek = startOfWeek + 6; // End of current week (Sunday)
      return {
        startDate: new Date(today.setDate(startOfWeek)),
        endDate: new Date(today.setDate(endOfWeek)),
      };
    }
    case "LAST WEEK": {
      const today = new Date();
      const lastWeekStart = today.getDate() - today.getDay() - 7; // Start of last week (Sunday)
      const lastWeekEnd = lastWeekStart + 6; // End of last week (Saturday)
      return {
        startDate: new Date(today.setDate(lastWeekStart)),
        endDate: new Date(today.setDate(lastWeekEnd)),
      };
    }
    case "CUSTOM DATE": {
      const today = new Date();
      const lastWeekStart = today.getDate() - today.getDay() - 7; // Start of last week (Sunday)
      const lastWeekEnd = lastWeekStart + 6; // End of last week (Saturday)
      return {
        startDate: new Date(today.setDate(lastWeekStart)),
        endDate: new Date(today.setDate(lastWeekEnd)),
      };
    }
    case "QUARTER TO DATE": {
      const today = new Date();
      const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3; // Start month of the quarter
      const quarterStartDate = new Date(
        today.getFullYear(),
        quarterStartMonth,
        1
      ); // Start date of the quarter
      return { startDate: quarterStartDate, endDate: today };
    }
    case "YEAR TO DATE": {
      const today = new Date();
      const yearStartDate = new Date(today.getFullYear(), 0, 1); // Start date of the current year (January 1st)
      return { startDate: yearStartDate, endDate: today };
    }
    default:
      break;
  }
};

export const statusType = (type?: string) => {
  switch (type) {
    case "DRAFT":
      return "Draft";
    case "ACTIVE":
      return "Active";
    case "INACTIVE":
      return "InActive";
    default:
      break;
  }
};

export const CollectionCategoryType = (type?: string) => {
  switch (type) {
    case "COMPONENT":
      return "COMPONENT";
    case "PAGE":
      return "PAGE";
    case "SCREEN":
      return "SCREEN";
    default:
      break;
  }
};

export const getFirstAvailableCollectionData = (
  obj: Record<string, any>,
  keys: string[] = ["components", "pages", "screens"]
): { key: string | null; value: any[] } => {
  for (const key of keys) {
    if (Array.isArray(obj?.[key])) {
      return { key, value: obj[key] };
    }
  }
  return { key: null, value: [] };
};
